module.exports = __webpack_public_path__ + "img/chat.2bfd39df.png";